import React from "react";

const ClientStories = () => {
  const clients = [
            {
        name: "M Saeed",
        location: "Riyadh, Saudi Arabia",
        initial: "M",
        review:
            "Consistent quality and excellent packaging. The freshness of the produce is maintained even after long-distance shipping. Highly dependable export partner.",
        },
        {
        name: "Li Turner",
        location: "Sydney, Australia",
        initial: "L",
        review:
            "Impressive quality standards and timely deliveries. Their attention to detail and commitment to freshness makes them stand out in the global market.",
        },
    {
      name: "Isabelli Gar",
      location: "Barcelona, Spain",
      initial: "I",
      review:
        "Reliable export partner with excellent packaging standards. We’ve seen great consistency in every order.",
    },
    {
      name: "Michael",
      location: "Kuala Lumpur, Malaysia",
      initial: "M",
      review:
        "Fast delivery and premium product quality. Their logistics coordination is smooth and dependable.",
    },
  ];

  return (
    <div style={styles.container}>
      <p style={styles.tag}>- TESTIMONIALS -</p>

      <h1 style={styles.heading}>
        What Our <span style={styles.highlight}>Partners Say</span>
      </h1>

      <p style={styles.desc}>
        Building trust through quality, consistency, and global delivery excellence.
      </p>

      <div style={styles.wrapper}>
        {clients.map((client, index) => (
          <div key={index} style={styles.card}>
            
            {/* Stars */}
            <div style={styles.stars}>
              {[1, 2, 3, 4, 5].map((_, i) => (
                <span key={i} style={styles.star}>★</span>
              ))}
            </div>

            {/* Quote */}
            <div style={styles.quote}>“</div>

            {/* Review */}
            <p style={styles.review}>{client.review}</p>

            {/* Profile */}
            <div style={styles.profile}>
              <div style={styles.avatar}>{client.initial}</div>
              <div>
                <p style={styles.name}>{client.name}</p>
                <p style={styles.location}>{client.location}</p>
              </div>
            </div>

          </div>
        ))}
      </div>
    </div>
  );
};

const styles = {
  container: {
    padding: "90px 20px",
    textAlign: "center",
    fontFamily: "'Poppins', sans-serif",
    color: "#fff",
    // background: "linear-gradient(135deg, #0f172a, #020617)",
  },

  tag: {
    color: "#38bdf8",
    letterSpacing: "4px",
    fontSize: "14px",
    marginBottom: "10px",
  },

 heading: {
  fontSize: "clamp(39px, 5vw, 48px)",
  fontWeight: "600",
  marginBottom: "20px",
  fontFamily: "'Playfair Display', serif",
  color: "#111",
  lineHeight: "0.9",
  letterSpacing: "-0.5px",
},

highlight: {
  background: "linear-gradient(90deg, #16a34a, #22c55e, #4ade80)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  fontStyle: "italic",
},

  desc: {
    color: "#94a3b8",
    marginBottom: "60px",
    fontSize: "15px",
  },

  wrapper: {
    display: "flex",
    justifyContent: "center",
    gap: "30px",
    flexWrap: "wrap",
  },

  card: {
    width: "300px",
    padding: "30px",
    borderRadius: "20px",
    // background: "rgba(30, 30, 29, 0.8)",
    background:"#f3f0ea",
    backdropFilter: "blur(10px)",
    border: "1px solid rgba(255,255,255,0.1)",
    textAlign: "left",
    transition: "0.3s",
    cursor: "pointer",
  },

  /* ⭐ NEW STAR STYLES */
  stars: {
    display: "flex",
    gap: "6px",
    marginBottom: "15px",
  },

  star: {
    fontSize: "14px",
    background: "linear-gradient(135deg, #facc15, #f59e0b)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    textShadow: "0 0 8px rgba(250, 204, 21, 0.4)",
  },

  quote: {
    fontSize: "40px",
    color: "#22c55e",
    marginBottom: "10px",
  },

  review: {
    fontSize: "15px",
    color: "#29292a",
    lineHeight: "1.7",
    marginBottom: "25px",
  },

  profile: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },

  avatar: {
    width: "50px",
    height: "50px",
    borderRadius: "12px",
    background: "linear-gradient(135deg, #22c55e, #16a34a)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "bold",
    color: "#fff",
    fontSize: "18px",
  },

  name: {
    margin: 0,
    color:"black",
    fontWeight: "600",
  },

  location: {
    margin: 0,
    fontSize: "12px",
    color: "#94a3b8",
  },
};

export default ClientStories;